"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changesDetection = void 0;

var _RgbaImageBuffer = _interopRequireDefault(require("../RgbaImageBuffer"));

var _exceptions = require("../exceptions");

var _imagesDifference = require("./imagesDifference");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Detects and highlights the changes of two images
 * according to the given threshold
 *
 * @param {RgbaImageBuffer} firstImgBuffer First image
 * @param {RgbaImageBuffer} secondImgBuffer Second image
 * @param {Number} threshold Threshold for considering a change as a important change
 * @param {Object} changeHighlightColor Color for highlight pixels considered as a change
 * @returns {RgbaImageBuffer} Changes map
 */


var changesDetection = function changesDetection(firstImgBuffer, secondImgBuffer, threshold, changeHighlightColor) {
  var difference;

  try {
    difference = (0, _imagesDifference.imagesDifference)(firstImgBuffer, secondImgBuffer);
  } catch (error) {
    if (error.name === "ImagesDifferenceException") throw new _exceptions.ImageOperationException("ChangesDetectionException", error.message);else throw error;
  }

  var result = firstImgBuffer.copy();

  for (var i = 0; i < result.pixels.length; i += _RgbaImageBuffer.default.NUM_CHANNELS) {
    if (difference.pixels[i] > threshold) {
      result.pixels[i] = changeHighlightColor.r;
      result.pixels[i + 1] = changeHighlightColor.g;
      result.pixels[i + 2] = changeHighlightColor.b;
    }
  }

  return result;
};

exports.changesDetection = changesDetection;